// Core
import React, { useEffect, useState } from 'react';
import { Redirect, Route, Switch, useLocation } from 'react-router-dom';
import { BsArrowLeft } from 'react-icons/bs';
import theme from 'theme/theme.js';
import routes from 'routes.js';
import { Box, Image, Link, Flex, ChakraProvider, useColorModeValue, useColorMode } from '@chakra-ui/react';

// Assets
import mainAuthImage from 'assets/img/main-auth-image.png';
import mainAuthLinesImage from 'assets/img/main-auth-image-lines.png';
import mainForgotImage from 'assets/img/main-forgot-image.png';
import animatedHome from 'assets/img/login/home.png';
import animatedCar1 from 'assets/img/login/car1.png';
import animatedCar2 from 'assets/img/login/car2.png';
import animatedCrystal from 'assets/img/login/crystal.png';
import animatedTicket from 'assets/img/login/ticket.png';
import animatedBox from 'assets/img/login/box.png';
import animatedLine from 'assets/img/login/line.png';

// Components
import { MapIcon } from 'components/Icons/Icons';

export default function Pages(props) {
  const wrapper = React.createRef();
  React.useEffect(() => {
    document.body.style.overflow = 'unset';
    return function cleanup() {};
  });

  const [step, setStep] = useState(1);

  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.collapse) {
        return getRoutes(prop.views);
      }
      if (prop.layout === '/auth') {
        return <Route path={prop.layout + prop.path} key={key}>
          { routerProps => 
              <prop.component {...routerProps} 
                step={step} setStep={setStep}  />
          }
        </Route>;
      } else {
        return null;
      }
    });
  };
  const navRef = React.useRef();
  document.documentElement.dir = 'ltr';

  const [page, setPage] = useState('login');
  const location = useLocation();
  useEffect(() => {
    if (location.pathname === '/auth/forgot') {
      setPage('forgot');
    } if (location.pathname === '/auth/sign-up') {
      setPage('sign-up');
    } else {
      setPage('login');
    }
  }, [location]);

  const backdropFilter = 'blur(30px)';

  const leftArrowColor = useColorModeValue('blue.920', 'blue.900');

  const { colorMode } = useColorMode();
  const isDark = colorMode === 'dark';

  return (
    <ChakraProvider theme={theme} resetCss={false} w='100%'>
      <Box ref={navRef} w='100%'>
        <Box w='100%'>
          <Box ref={wrapper} w='100%'>
            <Flex position='relative' mb='0px' h={{base: '100%', lg: '100vh'}}>
    		      <Flex
    		        h={{ sm: 'initial', md: '100%' }}
    		        w={{ base: '100%', sm: '80%', lg: '100%' }}
    		        maxW='1264px'
    		        mx='auto'
    		        justifyContent='space-between'
    		        mb='0px'
    		        pt={{ base: '40px', lg: '0' }}>
    		        <Flex
    		          alignItems='center'
    		          justifyContent='start'
    		          style={{ userSelect: 'none' }}
    		          w={step === 1 && page === 'sign-up' ? '100%' : { base: '100%', md: '50%', lg: '40%' }}
    		          ml={{ lg: '20px' }}
                  p={{base: '0 16px 16px 16px', md: '0'}}
    		          mb='10px'>
                      <Switch>
                        {getRoutes(routes)}
                        <Redirect from='/auth' to='/auth/404' />
                      </Switch>
    			       </Flex>

    		        <Box
    		          display={step === 1 && page === 'sign-up' ? 'none' : { base: 'none', md: 'block' }}
    		          overflowX='hidden'
    		          h={{ sm: '100%', md: '100%' }}
    		          w={{ sm: '0', md: '45%', lg: '50vw' }}
    		          position='absolute'
    		          right='0px'
    		          >
    		          <Box
    		            w='100%'
    		            h='100%'
    		            overflow='hidden'
    		            position='absolute'>
    	            	<MapIcon position="absolute" fontSize="1360px" 
    		                style={{zIndex: '-1', maxWidth: '1260px', w: '100%', left: '-60%', top: '10%', height: 'auto', opacity: '0.1'}}/>
    		            <Box 
                      position="relative" 
                      h={page === 'login' || page === 'sign-up' ? {base: '70%', lg: '90%'} : ''} 
                      left={ page === 'login' || page === 'sign-up' ? {base: '-10%', lg: '0'} : ''}
                      transform={ page === 'login' || page === 'sign-up' ? {base: 'scale(0.7)', lg: 'scale(1)'} : ''}>
                      { page !== 'forgot' ? (
                          <Box position="absolute" className="animation-prizes" bottom="10%" left="25%" w="400px" h="400px">
                            { isDark && <Box w="400px" h="400px" position="absolute" bg="#099BFF" filter="blur(90px)" borderRadius="full" left="-10%" top="-10%" className="animation-prizes-gradient"/>}
                            <Image src={animatedHome} alt="Home" w="325px" bottom="-4px" left="-2px" className="animation-prizes-home" zIndex="8" />
                            <Image src={animatedCar1} alt="Car" w="205px" bottom="8px" left="-82px" transform="rotate(0deg)" className="animation-prizes-car1" zIndex="7" />
                            <Image src={animatedCar2} alt="Car" w="205px" bottom="-1px" right="-16px" transform="rotate(0deg)" className="animation-prizes-car2" zIndex="7" />
                            <Image src={animatedCrystal} alt="Crystal" w="100px" bottom="119px" left="-66px" transform="rotate(-22deg)" zIndex="6" className="animation-prizes-crystal1" />
                            <Image src={animatedCrystal} alt="Crystal" w="145px" bottom="140px" left="-30px" transform="rotate(19deg)" zIndex="6" className="animation-prizes-crystal2" />
                            <Image src={animatedTicket} alt="Ticket" w="110px" bottom="136px" right="86px" transform="rotate(-44deg)" zIndex="5" className="animation-prizes-ticket1" />
                            <Image src={animatedTicket} alt="Ticket" w="70px" bottom="141px" right="53px" transform="rotate(-119deg)" zIndex="5" className="animation-prizes-ticket2" />
                            <Image src={animatedBox} alt="Box" w="300px" bottom="33px" left="-6px" transform="rotate(15deg) scale(1)" zIndex="1" className="animation-prizes-box" />
                            <Image src={animatedLine} opacity='0.04' w="100px" alt="Line" bottom="230px" left="-26px" transform="rotate(-36deg)" zIndex="2" className="animation-prizes-line1" />
                            <Image src={animatedLine} opacity='0.04' w="100px" alt="Line" bottom="250px" left="35px" transform="rotate(-17deg)" zIndex="2" className="animation-prizes-line2" />
                            <Image src={animatedLine} opacity='0.04' w="100px" alt="Line" bottom="260px" left="97px" transform="rotate(1deg)" zIndex="2" className="animation-prizes-line3" />
                            <Image src={animatedLine} opacity='0.04' w="100px" alt="Line" bottom="240px" left="160px" transform="rotate(21deg)" zIndex="2" className="animation-prizes-line4" />
                            <Image src={animatedLine} opacity='0.04' w="100px" alt="Line" bottom="223px" right="77px" transform="rotate(38deg)" zIndex="2" className="animation-prizes-line5" />
                          </Box>
                        ) : (
                          <>
                            <Box className="abstract-grad" mt="50%" left="50%" transform="translate(-70%, -20%) scale(1.2)" />
                            <Image src={mainForgotImage} alt="Forgot image" maxW="50%" left="20%" position="absolute" mt="15%" />
                          </>
                        )}
                    </Box>
    		          </Box>
    		        </Box>
		          </Flex>
            </Flex>
          </Box>
        </Box>
      </Box>
    </ChakraProvider>
  );
}